export const THUNK_PREFIXES = {
  fetchUserProfile: 'userProfile',
};
